@if (alwaysVisible || (data && data.todo && (data.todo.length || data.inProgress.length || data.done.length))) {
  <div>
    <div class="p-dsplyr tables">
      <div
        class="p-dsplyr-bx drop-list"
        cdkDropList
        #todoList="cdkDropList"
        [cdkDropListData]="data.todo"
        [cdkDropListConnectedTo]="[progressList, doneList]"
        [id]="'todo'"
        (cdkDropListDropped)="drop($event)"
      >
        <b>{{ 'ToDo.Todo' | translate }}</b>
        @for (element of data.todo; track element) {
          <mat-card appearance="outlined" class="p-dsplyr-item drag-item" cdkDrag (click)="openPopContent(element)">
            <mat-card-content class="p-0">
              <div class="body">{{ element.title }}</div>
              <div class="footer">
                <div>
                  <span>
                    <b>{{ element.creator ? element.creator.firstName + ' ' + element.creator.lastName : 'Inconnu' }}</b>
                  </span>
                  <span>| {{ element.formattedStart }}</span>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        }
        <div class="controls">
          <button mat-button color="primary" (click)="createTodo()">
            {{ 'ToDo.CreateTodo' | translate }}
          </button>
        </div>
      </div>
      <div
        class="p-dsplyr-bx"
        cdkDropList
        #progressList="cdkDropList"
        [cdkDropListData]="data.inProgress"
        [cdkDropListConnectedTo]="[todoList, doneList]"
        [id]="'inProgress'"
        (cdkDropListDropped)="drop($event)"
      >
        <b>{{ 'ToDo.InProgress' | translate }}</b>
        @for (element of data.inProgress; track element) {
          <mat-card appearance="outlined" class="p-dsplyr-item drag-item" cdkDrag (click)="openPopContent(element)">
            <mat-card-content class="p-0">
              <div class="body">{{ element.title }}</div>
              <div class="footer">
                <div>
                  <span>
                    <b>{{ element.creator ? element.creator.firstName + ' ' + element.creator.lastName : 'Inconnu' }}</b>
                  </span>
                  <span>| {{ element.formattedStart }}</span>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        }
      </div>
      <div class="p-dsplyr-bx" cdkDropList #doneList="cdkDropList" [cdkDropListData]="data.done" [cdkDropListConnectedTo]="[todoList, progressList]" [id]="'done'" (cdkDropListDropped)="drop($event)">
        <b>{{ 'ToDo.Done' | translate }}</b>
        @for (element of data.done; track element) {
          <mat-card appearance="outlined" class="p-dsplyr-item drag-item" cdkDrag (click)="openPopContent(element)">
            <mat-card-content class="p-0">
              <div class="body">{{ element.title }}</div>
              <div class="footer">
                <div>
                  <span>
                    <b>{{ element.creator ? element.creator.firstName + ' ' + element.creator.lastName : 'Inconnu' }}</b>
                  </span>
                  <span>| {{ element.formattedStart }}</span>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        }
      </div>
    </div>
  </div>
}
